// 支付产品类型
export enum ProductType {
  TOPUP = 'topup',     // 充值加油包
  SUBSCRIPTION = 'subscription' // 订阅
}

// 订阅周期
export enum BillingCycle {
  MONTHLY = 'monthly', // 按月
  YEARLY = 'yearly'    // 按年
}

// 支付产品接口定义
export interface PaymentProduct {
  publicId: string;
  code: string;
  title: string;
  description?: string;
  displayPrice: number; // 显示价格，单位：分
  price: number;        // 实际价格，单位：分
  mcoinAmount: number;  // M币数量
  type: ProductType;    // 产品类型: 充值包 or 订阅
  billingCycle?: BillingCycle; // 订阅周期，仅订阅类型有此字段
  features?: string[];  // 产品特性列表，用于UI展示
  discountPercent?: number; // 折扣百分比
}

// 订阅状态
export enum SubscriptionStatus {
  ACTIVE = 'active',         // 活跃
  CANCELED = 'canceled',     // 已取消但未到期
  EXPIRED = 'expired',       // 已过期
  PAYMENT_FAILED = 'payment_failed' // 支付失败
}

// 用户订阅信息
export interface UserSubscription {
  publicId: string;
  userId: string;
  productId: string;
  productCode: string;
  subscriptionStatus: SubscriptionStatus;
  startDate: string;
  endDate: string;
  autoRenew: boolean;
  billingCycle: BillingCycle;
  nextBillingDate?: string;
}

// M币记录类型映射
export const MCoinRecordTypeMap = {
  add: '收入',
  cost: '支出',
  refund: '退款',
  subscription: '订阅',
}; 